module.exports = __webpack_public_path__ + "static/coop-3b82fbb1cda9c7935e367ab0b8a3f037.jpg";